// Two-factor authentication screen translations for all 11 supported languages

export const twoFactorTranslations = {
  pt: {
    title: "Autenticação de dois fatores",
    description: "Introduza o código de 6 dígitos da sua app de autenticação para continuar.",
    code_label: "Código de autenticação",
    code_placeholder: "123 456",
    use_recovery_code: "Usar um código de recuperação",
    recovery_hint: "Os códigos de recuperação só podem ser usados uma vez.",
    remember_device: "Lembrar este dispositivo",
    remember_device_hint: "Evite pedir um código neste dispositivo durante 30 dias.",
    verify_button: "Verificar e continuar",
    verifying: "A verificar...",
    back_to_login: "Voltar ao login",
    service_unavailable: "O serviço está temporariamente indisponível. Tente novamente em breve.",
    error_required_code: "Introduza o código de autenticação.",
    error_invalid: "Esse código não é válido. Tente novamente.",
    error_session_expired: "A sua sessão expirou. Faça login novamente.",
    error_generic: "Não foi possível verificar o código.",
    email_hint: "A entrar como {{email}}",
  },
  en: {
    title: "Two-factor authentication",
    description: "Enter the 6-digit code from your authenticator app to continue.",
    code_label: "Authentication code",
    code_placeholder: "123 456",
    use_recovery_code: "Use a recovery code",
    recovery_hint: "Recovery codes can only be used once.",
    remember_device: "Remember this device",
    remember_device_hint: "Skip codes on this device for 30 days.",
    verify_button: "Verify and continue",
    verifying: "Verifying...",
    back_to_login: "Back to login",
    service_unavailable: "The service is temporarily unavailable. Please try again shortly.",
    error_required_code: "Enter your authentication code.",
    error_invalid: "That code is not valid. Try again.",
    error_session_expired: "Your sign-in session expired. Please log in again.",
    error_generic: "Unable to verify your code.",
    email_hint: "Signing in as {{email}}",
  },
  es: {
    title: "Autenticación de dos factores",
    description: "Introduce el código de 6 dígitos de tu aplicación de autenticación para continuar.",
    code_label: "Código de autenticación",
    code_placeholder: "123 456",
    use_recovery_code: "Usar un código de recuperación",
    recovery_hint: "Los códigos de recuperación solo se pueden usar una vez.",
    remember_device: "Recordar este dispositivo",
    remember_device_hint: "Evita los códigos en este dispositivo durante 30 días.",
    verify_button: "Verificar y continuar",
    verifying: "Verificando...",
    back_to_login: "Volver al inicio de sesión",
    service_unavailable: "El servicio está temporalmente no disponible. Inténtalo de nuevo en breve.",
    error_required_code: "Introduce tu código de autenticación.",
    error_invalid: "Ese código no es válido. Inténtalo de nuevo.",
    error_session_expired: "Tu sesión ha caducado. Inicia sesión de nuevo.",
    error_generic: "No se pudo verificar el código.",
    email_hint: "Iniciando sesión como {{email}}",
  },
  et: {
    title: "Kaheastmeline autentimine",
    description: "Sisesta oma autentimisrakenduse 6-kohaline kood, et jätkata.",
    code_label: "Autentimiskood",
    code_placeholder: "123 456",
    use_recovery_code: "Kasuta taastamiskoodi",
    recovery_hint: "Taastamiskoode saab kasutada ainult üks kord.",
    remember_device: "Mäleta seda seadet",
    remember_device_hint: "Jäta koodid sellel seadmel 30 päevaks vahele.",
    verify_button: "Kinnita ja jätka",
    verifying: "Kontrollin...",
    back_to_login: "Tagasi sisselogimise juurde",
    service_unavailable: "Teenus pole hetkel saadaval. Proovi varsti uuesti.",
    error_required_code: "Sisesta autentimiskood.",
    error_invalid: "See kood ei ole kehtiv. Proovi uuesti.",
    error_session_expired: "Sisselogimisseanss aegus. Logi uuesti sisse.",
    error_generic: "Koodi ei õnnestunud kinnitada.",
    email_hint: "Sisselogimine kasutajana {{email}}",
  },
  de: {
    title: "Zwei-Faktor-Authentifizierung",
    description: "Gib den 6-stelligen Code aus deiner Authenticator-App ein, um fortzufahren.",
    code_label: "Authentifizierungscode",
    code_placeholder: "123 456",
    use_recovery_code: "Wiederherstellungscode verwenden",
    recovery_hint: "Wiederherstellungscodes können nur einmal verwendet werden.",
    remember_device: "Dieses Gerät merken",
    remember_device_hint: "Überspringe Codes auf diesem Gerät für 30 Tage.",
    verify_button: "Bestätigen und fortfahren",
    verifying: "Wird überprüft...",
    back_to_login: "Zurück zum Login",
    service_unavailable: "Der Dienst ist vorübergehend nicht verfügbar. Bitte versuche es später erneut.",
    error_required_code: "Bitte gib deinen Authentifizierungscode ein.",
    error_invalid: "Dieser Code ist ungültig. Bitte versuche es erneut.",
    error_session_expired: "Deine Sitzung ist abgelaufen. Bitte melde dich erneut an.",
    error_generic: "Der Code konnte nicht verifiziert werden.",
    email_hint: "Anmeldung als {{email}}",
  },
  fr: {
    title: "Authentification à deux facteurs",
    description: "Saisissez le code à 6 chiffres de votre application d’authentification pour continuer.",
    code_label: "Code d’authentification",
    code_placeholder: "123 456",
    use_recovery_code: "Utiliser un code de récupération",
    recovery_hint: "Les codes de récupération ne peuvent être utilisés qu’une seule fois.",
    remember_device: "Se souvenir de cet appareil",
    remember_device_hint: "Ignorer les codes sur cet appareil pendant 30 jours.",
    verify_button: "Vérifier et continuer",
    verifying: "Vérification...",
    back_to_login: "Retour à la connexion",
    service_unavailable: "Le service est temporairement indisponible. Veuillez réessayer bientôt.",
    error_required_code: "Saisissez votre code d’authentification.",
    error_invalid: "Ce code n’est pas valide. Réessayez.",
    error_session_expired: "Votre session a expiré. Veuillez vous reconnecter.",
    error_generic: "Impossible de vérifier le code.",
    email_hint: "Connexion en tant que {{email}}",
  },
  it: {
    title: "Autenticazione a due fattori",
    description: "Inserisci il codice a 6 cifre dalla tua app di autenticazione per continuare.",
    code_label: "Codice di autenticazione",
    code_placeholder: "123 456",
    use_recovery_code: "Usa un codice di recupero",
    recovery_hint: "I codici di recupero possono essere usati solo una volta.",
    remember_device: "Ricorda questo dispositivo",
    remember_device_hint: "Salta i codici su questo dispositivo per 30 giorni.",
    verify_button: "Verifica e continua",
    verifying: "Verifica in corso...",
    back_to_login: "Torna al login",
    service_unavailable: "Il servizio non è disponibile temporaneamente. Riprova tra poco.",
    error_required_code: "Inserisci il tuo codice di autenticazione.",
    error_invalid: "Questo codice non è valido. Riprova.",
    error_session_expired: "La sessione è scaduta. Accedi di nuovo.",
    error_generic: "Impossibile verificare il codice.",
    email_hint: "Accesso come {{email}}",
  },
  nl: {
    title: "Tweefactorauthenticatie",
    description: "Voer de 6-cijferige code uit je authenticator-app in om door te gaan.",
    code_label: "Authenticatiecode",
    code_placeholder: "123 456",
    use_recovery_code: "Een herstelcode gebruiken",
    recovery_hint: "Herstelcodes kunnen slechts één keer worden gebruikt.",
    remember_device: "Dit apparaat onthouden",
    remember_device_hint: "Sla codes over op dit apparaat voor 30 dagen.",
    verify_button: "Verifiëren en doorgaan",
    verifying: "Bezig met verifiëren...",
    back_to_login: "Terug naar inloggen",
    service_unavailable: "De service is tijdelijk niet beschikbaar. Probeer het later opnieuw.",
    error_required_code: "Voer je authenticatiecode in.",
    error_invalid: "Deze code is ongeldig. Probeer het opnieuw.",
    error_session_expired: "Je sessie is verlopen. Log opnieuw in.",
    error_generic: "De code kon niet worden geverifieerd.",
    email_hint: "Aanmelden als {{email}}",
  },
  sv: {
    title: "Tvåfaktorsautentisering",
    description: "Ange den 6-siffriga koden från din autentiseringsapp för att fortsätta.",
    code_label: "Autentiseringskod",
    code_placeholder: "123 456",
    use_recovery_code: "Använd en återställningskod",
    recovery_hint: "Återställningskoder kan bara användas en gång.",
    remember_device: "Kom ihåg den här enheten",
    remember_device_hint: "Hoppa över koder på den här enheten i 30 dagar.",
    verify_button: "Verifiera och fortsätt",
    verifying: "Verifierar...",
    back_to_login: "Tillbaka till inloggning",
    service_unavailable: "Tjänsten är tillfälligt otillgänglig. Försök igen snart.",
    error_required_code: "Ange din autentiseringskod.",
    error_invalid: "Den här koden är inte giltig. Försök igen.",
    error_session_expired: "Din session har gått ut. Logga in igen.",
    error_generic: "Det gick inte att verifiera koden.",
    email_hint: "Loggar in som {{email}}",
  },
  da: {
    title: "Tofaktorgodkendelse",
    description: "Indtast den 6-cifrede kode fra din autentificeringsapp for at fortsætte.",
    code_label: "Godkendelseskode",
    code_placeholder: "123 456",
    use_recovery_code: "Brug en gendannelseskode",
    recovery_hint: "Gendannelseskoder kan kun bruges én gang.",
    remember_device: "Husk denne enhed",
    remember_device_hint: "Spring koder over på denne enhed i 30 dage.",
    verify_button: "Bekræft og fortsæt",
    verifying: "Bekræfter...",
    back_to_login: "Tilbage til login",
    service_unavailable: "Tjenesten er midlertidigt utilgængelig. Prøv igen snart.",
    error_required_code: "Indtast din godkendelseskode.",
    error_invalid: "Denne kode er ikke gyldig. Prøv igen.",
    error_session_expired: "Din session er udløbet. Log ind igen.",
    error_generic: "Koden kunne ikke verificeres.",
    email_hint: "Logger ind som {{email}}",
  },
  fi: {
    title: "Kaksivaiheinen tunnistautuminen",
    description: "Syötä todennussovelluksen 6-numeroinen koodi jatkaaksesi.",
    code_label: "Todennuskoodi",
    code_placeholder: "123 456",
    use_recovery_code: "Käytä palautuskoodia",
    recovery_hint: "Palautuskoodit voi käyttää vain kerran.",
    remember_device: "Muista tämä laite",
    remember_device_hint: "Ohita koodit tällä laitteella 30 päivän ajan.",
    verify_button: "Vahvista ja jatka",
    verifying: "Vahvistetaan...",
    back_to_login: "Takaisin kirjautumiseen",
    service_unavailable: "Palvelu on tilapäisesti poissa käytöstä. Yritä uudelleen hetken kuluttua.",
    error_required_code: "Syötä todennuskoodi.",
    error_invalid: "Tämä koodi ei kelpaa. Yritä uudelleen.",
    error_session_expired: "Istuntosi on vanhentunut. Kirjaudu uudelleen.",
    error_generic: "Koodia ei voitu vahvistaa.",
    email_hint: "Kirjaudutaan sisään käyttäjänä {{email}}",
  },
};
